import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0087',
    ecrans: ['00-2'],
    params: ['refcleint']

});

